import { render, staticRenderFns } from "./SurveysStats.vue?vue&type=template&id=2ebfe7df&scoped=true&"
import script from "./SurveysStats.vue?vue&type=script&lang=js&"
export * from "./SurveysStats.vue?vue&type=script&lang=js&"
import style0 from "./SurveysStats.vue?vue&type=style&index=0&id=2ebfe7df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfe7df",
  null
  
)

export default component.exports